import AdminStatCard from "./AdminStatCard";
import SortableMetricTable, { type Column } from "./SortableMetricTable";

type Stat = {
  title: string;
  value: string;
  description: string;
  formula: string;
};

type Props<TRow extends { merchantId: string }> = {
  title: string;
  description?: string;
  stats: Stat[];
  summary?: React.ReactNode;
  columns: Column<TRow>[];
  rows: TRow[];
  defaultSort: { columnKey: string; direction: "asc" | "desc" };
  emptyMessage?: string;
};

const MetricSection = <TRow extends { merchantId: string }>({
  title,
  description,
  stats,
  summary,
  columns,
  rows,
  defaultSort,
  emptyMessage,
}: Props<TRow>) => (
  <section className="flex flex-col gap-4">
    <div className="flex flex-col gap-1">
      <h2 className="text-lg font-semibold text-palomma-secondary">{title}</h2>
      {description && <p className="text-sm text-gray-500">{description}</p>}
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {stats.map((stat) => (
        <AdminStatCard
          key={stat.title}
          title={stat.title}
          value={stat.value}
          description={stat.description}
          formula={stat.formula}
        />
      ))}
    </div>

    {summary && <p className="text-xs text-gray-500">{summary}</p>}

    <SortableMetricTable
      rows={rows}
      columns={columns}
      defaultSort={defaultSort}
      emptyMessage={emptyMessage}
    />
  </section>
);

export default MetricSection;
